export const DEFAULT_USER_STREAM_LIMIT = 3;
export const DEFAULT_USER_STREAM_BUFFER_SIZE = 10;
export const DEFAULT_USER_STREAM_REFILL_THRESHOLD = 6;
export const WHO_TO_FOLLOW_USER_LIMIT = 3;
export const WHO_TO_FOLLOW_BUFFER_SIZE = 10;
export const WHO_TO_FOLLOW_REFILL_THRESHOLD = 6;
// How many recommendations the page keeps available; the cached stream is shown whole, and Nexus is
// asked in pages of NEXUS_USER_STREAM_MAX_LIMIT
export const WHO_TO_FOLLOW_PAGE_SIZE = 30;
